// extracted by mini-css-extract-plugin
export default {"wrap":"FG-z","fullWidth":"GG-z","hideOnDesktop":"HG-z","content":"IG-z","hasOpenedNav":"JG-z","crumbsList":"KG-z","dropdownsWrap":"LG-z"};